import { toast } from 'react-toastify';
import { useBoolean } from 'react-use';
import { RoutePlanStatus } from '@/api/apis/case';
import { retrieveUnifiedError } from '@/api/utils';
import { useMoveRouteToNextStatusMutation } from '@/queries/case';

export const useUpdateRouteStatus = () => {
  const [isSubmitting, setIsSubmitting] = useBoolean(false);
  const { mutateAsync: mutateRouteStatus } = useMoveRouteToNextStatusMutation();

  const updateStatus = async (
    caseId: string,
    currentStatus: RoutePlanStatus,
    comment?: string,
    isSendQuoteInternalMain?: boolean,
  ) => {
    try {
      setIsSubmitting(true);
      await mutateRouteStatus({ caseId, currentStatus, comment, isSendQuoteInternalMain });
      toast.success('Route status successfully updated');
    } catch (error) {
      const { message } = retrieveUnifiedError(error);
      toast.error(message);

      // Handle errors on modal to leave it opened
      if (currentStatus === RoutePlanStatus.RoutePlanningStart) {
        throw error;
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  return { updateStatus, isSubmitting };
};
